'use strict';

const Backbone = require('backbone');
const CollectionView = require('./loading.js').CollectionView;
const _ = require('lodash');

module.exports = CollectionView.extend({
    childViewEventPrefix: 'widgets',

    getChildView: function (child) {
        const me = this;

        return _.result(me, 'childView') || child.view;
    },

    childViewOptions: function (model) {
        return {
            dashboardModel: model
        };
    },

    filter: _.identity,

    // Handle filtered views without re-rendering
    refresh: function () {
        const me = this;

        // Remove widgets that are now filtered
        me.children.each(function (child) {
            if (!me.filter(child.dashboardModel)) {
                me.removeChildView(child);
            }
        });

        _.each(me._filteredSortedModels(), function (model) {
            const child = me.children.findByModel(model);

            if (!child) {
                // Add widgets that were previously filtered
                me._onCollectionAdd(model, me.collection, {});
            }
        });
    },

    renderChildView: function (view, index) {
        const me = this;

        if (view.isRendered && view.reloadable) {
            me.attachHtml(me, view, index);
            return view;
        }

        return CollectionView.prototype.renderChildView.apply(me, arguments);
    },

    initialize: function (options) {
        const me = this;
        me.cachedChildren = new Backbone.ChildViewContainer();
        _.extend(me, _.pick(options, 'flushData'));
    }
});
